import { ref } from "vue"
import { sleep } from "../../lib/util/util.js"
import EpisodeService from "../../services/EpisodeService"

const error = ref(null)
const loading = ref(false)
const episodes = ref([])

const getLatestEpisodes = async (episodeCount, podcastID) => {
	loading.value = true
	await sleep(1000)
	try {
		episodes.value = await EpisodeService.Latest(episodeCount, podcastID)
		error.value = null
		loading.value = false
	} catch (err) {
		error.value = err.message
		loading.value = false
	}
}

const useGetLatestEpisodes = () => {
	return { error, loading, episodes, getLatestEpisodes }
}

export default useGetLatestEpisodes